import logo from '@assets/images/logo.svg';

function Header(paddingTop) {
  return (
    <nav
      className="flex flex-row justify-center items-center"
      style={{
        paddingTop: paddingTop,
      }}
    >
      <img src={logo} alt="Port Mall Logo" className="w-45 my-3.5" />
    </nav>
  );
}

export default Header;
